export default __webpack_public_path__ + "static/2020-2-5846e8ebadff9119bcf9ad75faf19675.jpg";